import {PopupMenuItem, modKeyName} from "@dv5/components"
import {ItemAction,} from "@dv5/domain"

export const menuItems: PopupMenuItem[] = [
    {action: ItemAction.COPY, title: `Copy (${modKeyName()}+C)`},
    {action: ItemAction.CLONE, title: `Duplicate (${modKeyName()}+D)`},
    {action: ItemAction.ADD_DATA_LINK, title: 'Add Data Link'},
    {action: ItemAction.ADD_COMMENT, title: 'Comments...'},
    {action: ItemAction.MOVE_TO_LAYERS, title: 'Layers...'},
    {action: ItemAction.ASSIGN_TO_TAGS, title: 'Tags...'},
    {action: ItemAction.SAVE_AS_TEMPLATE, title: 'Save as a template...'},
    {action: ItemAction.TOGGLE_LOCKED, title: 'Toggle locked'},
    {action: ItemAction.DELETE, title: 'Delete (Del)'},
]

export const READ_ONLY_CANVAS_ACTIONS: ReadonlySet<ItemAction> = new Set([
    ItemAction.COPY, ItemAction.ADD_COMMENT, ItemAction.ADD_DATA_LINK, ItemAction.SAVE_AS_TEMPLATE,
])
